import { render, staticRenderFns } from "./InvoiceDiffPopup.vue?vue&type=template&id=07cf32de&"
import script from "./InvoiceDiffPopup.vue?vue&type=script&lang=js&"
export * from "./InvoiceDiffPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports